export type Lang = 'de' | 'en' | 'it';
export const LANGS: Lang[] = ['de', 'en', 'it'];
export const DEFAULT_LANG: Lang = 'de';

export type ContentMap = Record<string, string>;
export type AllContent = Record<Lang, ContentMap>;

export type MediaType = 'SINGLE' | 'GALLERY' | 'CUSTOMER_LOGO';

export interface CustomerLogo {
  name: string;
  url: string;
}

export interface PublicMedia {
  single: Record<string, string>;      // slot -> url
  galleries: Record<string, string[]>; // group -> [url]
  customers: CustomerLogo[];
}

export interface MediaAsset {
  id: number;
  slot: string | null;
  type: MediaType;
  groupKey: string | null;
  filename: string;
  originalName: string | null;
  contentType: string | null;
  label: string | null;
  alt: string | null;
  sortOrder: number;
  url: string;
}

export interface LegalDoc {
  title: string;
  body: string;
}

export type LegalKey = 'privacy' | 'terms' | 'cookie';

export interface ContactPayload {
  name: string;
  company?: string;
  email: string;
  message: string;
  lang: Lang;
}

export interface ContactMessage {
  id: number;
  name: string;
  company: string | null;
  email: string;
  message: string;
  lang: string;
  ip: string | null;
  createdAt: string;
}

export interface ContentBlockDto {
  key: string;
  lang: Lang;
  value: string;
  format?: 'TEXT' | 'HTML';
}

/** Resolved-per-language shapes returned by the public collection endpoints. */
export interface PublicProduct {
  id: number;
  featured?: boolean;
  tag: string | null;
  title: string;
  desc: string;
  previewUrl: string | null;
  gallery: string[];
}
export interface CapacityView { num: string; label: string; }
export interface PublicService {
  id: number;
  featured?: boolean;
  icon: string | null;
  title: string;
  desc: string;
  gallery: string[];
  capacities: CapacityView[];
}
export interface PublicCertification { id: number; icon: string | null; name: string; desc: string; }
export interface PublicLocation { id: number; mapUrl: string | null; title: string; address: string; }
export interface PublicFaq { id: number; category: string | null; question: string; answer: string; }

export type CollectionKey = 'products' | 'services' | 'certifications' | 'locations' | 'faq';

/** Raw admin entity DTOs (all-language columns, as persisted). */
export interface Sortable { id?: number | null; sortOrder: number; active: boolean; }

export interface ProductItemDto extends Sortable {
  featured?: boolean;
  tag?: string | null;
  previewSlot?: string | null;
  galleryGroup?: string | null;
  titleDe?: string; titleEn?: string; titleIt?: string;
  descDe?: string; descEn?: string; descIt?: string;
}
/** One capacity row inside ServiceItemDto.capacities (stored as JSON string). */
export interface CapacityRow { num: string; labelDe: string; labelEn: string; labelIt: string; }
export interface ServiceItemDto extends Sortable {
  featured?: boolean;
  icon?: string | null;
  galleryGroup?: string | null;
  titleDe?: string; titleEn?: string; titleIt?: string;
  descDe?: string; descEn?: string; descIt?: string;
  capacities?: string | null; // JSON of CapacityRow[]
}
export interface CertificationItemDto extends Sortable {
  icon?: string | null;
  name?: string | null;
  descDe?: string; descEn?: string; descIt?: string;
}
export interface LocationItemDto extends Sortable {
  mapUrl?: string | null;
  titleDe?: string; titleEn?: string; titleIt?: string;
  addressDe?: string; addressEn?: string; addressIt?: string;
}
export interface FaqItemDto extends Sortable {
  category?: string | null;
  questionDe?: string; questionEn?: string; questionIt?: string;
  answerDe?: string; answerEn?: string; answerIt?: string;
}

export interface ReorderItem { id: number; sortOrder: number; }
